export default __webpack_public_path__ + "static/media/customer.8bea83b7.png";